module.exports = __webpack_public_path__ + "static/media/restDayBoy.0b205d7a.svg";